const escapeHtml = (value: string): string => {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

const allowedProtocols = ['http:', 'https:', 'mailto:', 'tel:'] as const;

const sanitizeUrl = (value: string): string => {
  try {
    const parsed = new URL(value, 'https://example.com');
    const protocol = parsed.protocol as (typeof allowedProtocols)[number];
    if (!allowedProtocols.includes(protocol)) {
      return '#';
    }
    return value;
  } catch {
    return '#';
  }
};

const markdown2html = (src?: string): string => {
  if (!src) {
    return '';
  }

  let text = escapeHtml(src);

  // Bold
  text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  text = text.replace(/__(.+?)__/g, '<strong>$1</strong>');

  // Italic
  text = text.replace(/\*(.+?)\*/g, '<em>$1</em>');
  text = text.replace(/_(.+?)_/g, '<em>$1</em>');

  // Links: [label](url)
  text = text.replace(/\[([^[\]]+)\]\(([^)]+)\)/g, (_match, label, url) => {
    const safeUrl = sanitizeUrl(url);
    return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">${label}</a>`;
  });

  // Line breaks
  text = text.replace(/\n/g, '<br />');

  return text;
};

export default markdown2html;

